(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mbb-brand-overview"] && !Shopify.designMode) return;
  try {
    
(function () {

  function initBrandSection(section) {
    const input = section.querySelector('[data-brand-search]');
    const list  = section.querySelector('[data-brands-list]');
    if (!list) return;

    const items = Array.from(list.querySelectorAll('.brands-grid__item'));

    function applyFiltering() {
      if (!input) return;
      const query = input.value.toLowerCase().trim();

      items.forEach(item => {
        const name = item.dataset.brand || '';
        item.style.display = name.includes(query) ? '' : 'none';
      });
    }

    function applySorting() {
      const SORT_MODE = list.dataset.sortMode || 'alpha';

      if (SORT_MODE === 'random') {
        for (let i = items.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [items[i], items[j]] = [items[j], items[i]];
        }
      } else {
        items.sort((a, b) =>
          a.dataset.brand.localeCompare(b.dataset.brand, 'de', { sensitivity: 'base' })
        );
      }

      items.forEach(item => list.appendChild(item));
      applyFiltering(); // IMPORTANT
    }

    if (input) {
      input.addEventListener('input', applyFiltering);
    }

    applySorting();
  }

  function initAll() {
    document
      .querySelectorAll('.brands-overview')
      .forEach(initBrandSection);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);

})();

  } catch(e) { console.error(e); }
})();
})();
